module.exports = __webpack_public_path__ + "static/media/brandIcon.0e99ac40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brandIcon.svg
// module id = 500
// module chunks = 0